import React from "react";
import { Box, Typography } from "@mui/material";
import { NJIM } from "../../theme/njimTheme";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumb?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  breadcrumb,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {breadcrumb ? <Box sx={{ mb: 0.75 }}>{breadcrumb}</Box> : null}
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: 22, md: 24 },
            fontWeight: 700,
            color: NJIM.ink,
            lineHeight: 1.25,
            letterSpacing: "-0.02em",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            sx={{
              mt: 0.5,
              fontSize: 14,
              color: NJIM.textSecondary,
              lineHeight: 1.5,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 1,
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
};

export default PageHeader;
